"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const media_1 = require("./media");
const upload_1 = require("./media/upload");
const MultimediaSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const { schema } = props;
    const { rootPath } = schema;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
            react_1.default.createElement(upload_1.Upload, Object.assign({}, registerProps, { value: value, rootPath: rootPath, hasError: fieldState.invalid }))),
        react_1.default.createElement(media_1.Multimedia, { style: { border: "1px solid #ccc" }, src: value })));
};
MultimediaSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MultimediaDisplayComponent", (value) => {
    return react_1.default.createElement(media_1.Multimedia, { style: { backgroundColor: "#888" }, src: value });
});
exports.default = MultimediaSchemaComponent;
